
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux' // Redux 사용 시
import { getIsLoggedIn } from 'store/Slices/user'

const PrivateRoute = () => {
    const isLogin = useSelector(getIsLoggedIn)

    // 인증되지 않은 경우 로그인 페이지로 리다이렉트
    if (!isLogin) {
        return <Navigate to="/login" replace />
    }

    // !TODO requiredRole을 받아서 권한별 분기 처리 필요 (강사, 지역 담당자, 마스터)

    // 권한이 있으면 자식 라우트를 렌더링
    return <Outlet />
}

export default PrivateRoute